import { render, staticRenderFns } from "./ProductEditCompositionEditRow.vue?vue&type=template&id=dada8338&scoped=true"
import script from "./ProductEditCompositionEditRow.vue?vue&type=script&lang=ts"
export * from "./ProductEditCompositionEditRow.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditCompositionEditRow.vue?vue&type=style&index=0&id=dada8338&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dada8338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dada8338')) {
      api.createRecord('dada8338', component.options)
    } else {
      api.reload('dada8338', component.options)
    }
    module.hot.accept("./ProductEditCompositionEditRow.vue?vue&type=template&id=dada8338&scoped=true", function () {
      api.rerender('dada8338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditCompositionEditRow.vue"
export default component.exports